import { Expose } from 'class-transformer';

export class ReservationInfoModel {
    @Expose({ name: 'ReservationToken' })
    public reservationToken: string;

    @Expose({ name: 'ReservationValidUntil' })
    public reservationValidUntil?: string;

    @Expose({ name: 'ReservedItems' })
    public reservedItems: number;
}